import { getWechatUser } from './auth'

export function getRequestToken(storeToken) {
  const wechatUser = getWechatUser()
  if (wechatUser && wechatUser.token) {
    return wechatUser.token
  }

  return storeToken || ''
}



// WEBPACK FOOTER //
// ./src/utils/request-token.js